export enum EntityLimitTier {
  Infinite = 'Infinite',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  Network = 'Network'
}
